
import { defineComponent, ref } from 'vue';
import { random } from 'SharedDir/utils/helpers';

export default defineComponent({
  name: 'NewsSkeletonItem',
  methods: { random },

  setup() {
    return {};
  },
});
